module.exports = __webpack_public_path__ + "static/media/tool_wrench.056931f6.svg";